module.exports = __webpack_public_path__ + "img/W3.92e94593.png";